import React from "react";
import {Styles} from "../../../../../config/design/styles";
import {connect} from "trim-redux";
import axios from "axios";
import {defaultVariables} from "../../../../../config";
import {Autocomplete} from "@mui/lab";
import {withStyles} from "@mui/styles";
import {CircularProgress} from "@mui/material";
import {translateKey} from "../../../../../config/values";
import RayaField from "../../../../components/elements/fields/RayaField";

class UserChooserForCharity extends React.Component{
    state = {
        categories:[],
        selected:!!this.props.selected ? this.props.selected : null,
        loading:true,
        open:false,
    };
    async componentDidMount(){
        await this.loadData();
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        let {charity_id} = this.props;
        axios.get(`${defaultVariables.url}/users/charities/get-all${!!charity_id ? "/"+charity_id : '' }`, config)
            .then(async response => {
                let categories = response.data;
                let selected = null;
                let {default_id} = this.props;
                if(!!default_id){
                    selected = await categories.find(item => parseInt(item.id) === parseInt(default_id));
                    if(!!selected){
                        await this.handleType(selected)
                    }
                }
                await this.setState({
                    categories:response.data,
                    loading:false,
                })
            })
            .catch(error => {
                this.setState({
                    loading:false
                })
            });
    }
    handleType(data){
        this.props.handleRes(data);
        this.setState({
            selected:data
        })
    }
    render(){
        let {categories,loading,selected,open} = this.state;
        let{required,error,locale,size} = this.props;
        return (
            <>
                <Autocomplete
                    fullWidth
                    open={open}
                    onOpen={() => {
                        this.setState({open:true})
                    }}
                    onClose={() => {
                        this.setState({open:false})
                    }}
                    required={required}
                    getOptionLabel={(option) => option.first_name+" "+option.last_name + " ("+ (!!option.mobile ? option.mobile : option.email) +") "}
                    onChange={(event, value) => this.handleType(value)}
                    options={categories}
                    value={selected}
                    loading={loading}
                    size={!!size ? size : ''}
                    disabled={this.props.disabled}
                    renderInput={(params) => (
                        <RayaField
                            {...params}
                            label={translateKey('charityAccount')}
                            variant="outlined"
                            required={required}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <React.Fragment>
                                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            }}
                            error={error}
                            helperText={!!error && error}
                        />
                    )}
                />
            </>
        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    locale: state.locale,

});
export default withStyles(Styles)(connect(mstp)(UserChooserForCharity));